// extracted by mini-css-extract-plugin
module.exports = {"section":"reviews_section__PSGT4","background--contrast":"reviews_background--contrast__12r6j","button":"reviews_button__3MKZ2"};